<template>
  <transition name="fade" mode="out-in">
    <section id="pay-result">
      <top-header
        class="top-header"
        :showWebsite="false"
        :showLoginBtn="false"
        :showLangSelector="false"
      ></top-header>
      <div class="result-info-container">
        <PayState
          v-if="result == SUCCESS"
          class="result-type-wrapper"
          :tips="newStoreSuccessTips"
          :title="letter.storeSuccess"
          state="success"
        >
          <!-- 双倍券结果提示语 -->
          <template v-if="hasDoubleSend">
            <p class="opera-tips">{{ letter.doubleSendInfo }}</p>
          </template>
        </PayState>
        <PayState
          v-if="result == WAITING"
          class="result-type-wrapper"
          :tips="letter.storeSuccessTips"
          :title="letter.storeAcceptance"
          state="storing"
        ></PayState>
        <PayState
          v-if="result == FAIL"
          class="result-type-wrapper"
          :tips="letter.storeFailTips"
          :title="letter.storeFail"
          state="fail"
        ></PayState>
        <div class="order-info-wrapper">
          <div class="order-info-container">
            <div class="game-info">
              <span class="floatL">{{ letter.creatework_game }}</span>
              <span class="floatR">{{ gameName }}</span>
            </div>
            <div class="order-info">
              <div class="order-info-list">
                <span class="floatL">UID：</span>
                <span class="floatR">{{ userId || uid }}</span>
              </div>
              <div class="order-info-list">
                <span class="floatL">{{ letter.orderNumber }}：</span>
                <span class="floatR">{{ orderId }}</span>
              </div>
              <div class="order-info-list" v-if="isCart">
                <template v-if="+totalQuantity">
                  <span class="floatL">{{ letter.buyProduct }}：</span>
                  <span class="floatR look-detail" @click="lookOrderRecord">{{
                    letter.look_detail_of_cart
                  }}</span>
                  <span class="floatR">{{
                    letter.total_n_product.replace('${n}', totalQuantity)
                  }}</span>
                </template>
              </div>
              <div class="order-info-list" v-else>
                <span class="floatL">{{ letter.buyProduct }}：</span>
                <span class="floatR">{{ payResult }}</span>
              </div>
            </div>
            <ul class="payment-info">
              <li class="payment-info-list">
                <span class="floatL">{{ letter.couponOrderTotal }}：</span>
                <span class="floatR bigMark ltr-dire normal" v-if="isCart">
                  {{ cartPriceAmount }}
                  <span v-if="isShowTax && !hasUseCoupon">
                    {{ `+ ${curTax} ${currency}(tax)` }}
                  </span>
                </span>
                <span
                  class="floatR bigMark ltr-dire normal"
                  v-else-if="hasUseCoupon"
                >
                  {{ amountDesc }}
                  <span v-if="isShowTax && !hasUseCoupon">
                    {{ `+ ${curTax} ${currency}(tax)` }}
                  </span>
                </span>
                <span class="floatR bigMark ltr-dire normal" v-else>
                  <template v-if="isJpPlatform">
                    {{ priceAmount }}
                  </template>
                  <template v-else>
                    {{ `${amount}${currency}` }}
                    <span v-if="isShowTax">
                      {{ `+ ${curTax} ${currency}(tax)` }}
                    </span>
                  </template>
                </span>
              </li>
              <li class="payment-info-list" v-if="hasUseCoupon">
                <span class="floatL">{{ letter.couponCoupon }}：</span>
                <Mark class="floatR bigMark ltr-dire normal">
                  {{ couponInfoName }}
                </Mark>
              </li>
              <li class="payment-info-list" v-if="hasUseCoupon">
                <span class="floatL">{{ letter.transactionAmount }}：</span>
                <Mark class="floatR bigMark ltr-dire highlight">
                  {{ discountAfterAmount }}
                  <span v-if="isShowTax">
                    {{ `+ ${curTax} ${currency}(tax)` }}
                  </span>
                </Mark>
              </li>
              <li class="payment-info-list" v-if="result == FAIL">
                <span class="floatL">{{ letter.failReason }}：</span>
                <span class="floatR middleMark pay-errmsg">
                  {{ msg }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <p class="opera-tips mb0">{{ letter.screenshotTips }}</p>
        <template v-if="result == SUCCESS && showQuickPayTip">
          <p class="opera-tips mb0">{{ letter.quickcard_result_tip_one }}</p>
          <p class="opera-tips mb0">{{ letter.quickcard_result_tip_two }}</p>
          <p
            class="opera-tips look-more mb0"
            @click="isShowQuickPayPopup = true"
          >
            {{ letter.quickcard_learn_more }}
          </p>
        </template>
        <p class="opera-tips mb0" v-if="isCart">{{ letter.thirty_tip }}</p>
      </div>
      <div class="follow-operation" v-if="result == SUCCESS">
        <!-- 再储值一笔 -->
        <Button
          class="follow-operation-btn restore"
          pointClass="j-restore-btn"
          @click="reStore"
        >
          <span class="follow-operation-btn-text">
            {{ letter.payOntherORder }}
          </span>
        </Button>
      </div>
      <div class="follow-operation" v-if="result == WAITING">
        <!-- 再储值一笔 -->
        <Button
          class="follow-operation-btn restore"
          pointClass="j-restore-btn"
          @click="reStore"
          :loading="loading"
        >
          <span class="follow-operation-btn-text">
            {{ letter.payOntherORder }}
          </span>
        </Button>
      </div>
      <div class="follow-operation" v-if="result == FAIL">
        <Button
          class="follow-operation-btn contact-us"
          @click="showFeebackPage"
          pointClass="j-go-feeback-btn"
          v-if="!uidGame && needServiceBtn"
        >
          <span class="follow-operation-btn-text">
            {{ letter.contactService }}
          </span>
        </Button>
        <Button
          class="follow-operation-btn"
          pointClass="j-restore-btn"
          @click="reStore"
        >
          <span class="follow-operation-btn-text">
            {{ letter.reStore }}
          </span>
        </Button>
      </div>
      <form v-bind:action="postAction" method="post">
        <input
          type="hidden"
          name="cardType"
          v-bind:value="post_fields.cardType"
        />
        <input
          type="hidden"
          name="gatewayNo"
          v-bind:value="post_fields.gatewayNo"
        />
        <input
          type="hidden"
          name="goodsInfo"
          v-bind:value="post_fields.goodsInfo"
        />
        <input type="hidden" name="merNo" v-bind:value="post_fields.merNo" />
        <input
          type="hidden"
          name="notifyUrl"
          v-bind:value="post_fields.notifyUrl"
        />
        <input
          type="hidden"
          name="orderAmount"
          v-bind:value="post_fields.orderAmount"
        />
        <input
          type="hidden"
          name="orderCurrency"
          v-bind:value="post_fields.orderCurrency"
        />
        <input
          type="hidden"
          name="orderNo"
          v-bind:value="post_fields.orderNo"
        />
        <input type="hidden" name="remark" v-bind:value="post_fields.remark" />
        <input
          type="hidden"
          name="returnUrl"
          v-bind:value="post_fields.returnUrl"
        />
        <input
          type="hidden"
          name="shopperId"
          v-bind:value="post_fields.shopperId"
        />
        <input
          type="hidden"
          name="signInfo"
          v-bind:value="post_fields.signInfo"
        />
        <input type="hidden" name="token" v-bind:value="post_fields.token" />
        <input
          type="hidden"
          name="verifyBillingAddress"
          v-bind:value="post_fields.verifyBillingAddress"
        />
        <button type="submit" id="postOrderToBank" class="hide"></button>
      </form>
      <ServiceIconBtn
        v-if="result != FAIL && needServiceBtn"
        :serverId="sid"
        :roleId="roleId"
        :roleName="roleName"
        :gameId="gameId"
        :isUidLogin="isUidLogin"
        :uid="uid"
        :loginAccount="loginAccount"
      ></ServiceIconBtn>
      <QuickPayCardPopup
        @close="isShowQuickPayPopup = false"
        v-if="isShowQuickPayPopup"
        :languages="letter"
      ></QuickPayCardPopup>
      <CartOrderRecord
        :coinName="coinName"
        :currency="currency"
        :cartList="cartList"
        v-if="isShowOrderRecord"
        @close="isShowOrderRecord = false"
      ></CartOrderRecord>
      <theme-config v-if="showThemeConfig"></theme-config>
    </section>
  </transition>
</template>
<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import TopHeader from '@components/officialStore/TopHeader.vue';
import ServiceIconBtn from '@components/officialStore/ServiceIcon.vue';
import { b64DecodeUnicode, changePriceFormat } from '@utiles/officialStore';
import bridge from '@utiles/officialStore/bridge';
import { getWebviewPageFlag } from '@store/officialStore/storager';
import QuickPayCardPopup from '@components/officialStore/paytype/QuickPayCardPopup.vue';
import CartOrderRecord from '@components/officialStore/cart/CartOrderRecord.vue';
import { GET_CART } from '@store/officialStore/cart';
import { UPDATE_GAMEID } from '@store/officialStore';
import { commonEmitUpload } from '../../plugins/AnalyzePoint/index';
import gameInfoConfig from '@configs/officialStore/globalGameInfoConfig';
import { mapGetters, mapState } from 'vuex';
import jpService from '@mixins/officialStore/jpServiceLink';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV1';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();
let gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';
export default {
  name: 'resultPage',
  mixins: [jpService],
  data() {
    let store_url_params = decodeURIComponent(
      globalConfig.getHrefParam('store_url_params').replace('#/result', '')
    );
    let storeParams = b64DecodeUnicode(store_url_params);
    let postOrderParams = {};
    const webviewEnv = getWebviewPageFlag() == 1;
    try {
      const parsed = JSON.parse(storeParams);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        postOrderParams = parsed;
      }
    } catch (e) {
      console.error(e);
    }

    return {
      uidGame: globalConfig.isUidGame(),
      needServiceBtn: postOrderParams['hideService'] != 1,
      result: globalConfig.getHrefParam('result'),
      msg: globalConfig.getHrefParam('msg'),
      gameId: gameId,
      sid: globalConfig.getHrefParam('server_sid'),
      serverId: globalConfig.getHrefParam('server_id'),
      orderId: globalConfig.getHrefParam('order_id'),
      coin: globalConfig.getHrefParam('coin'),
      sub_coin: globalConfig.getHrefParam('sub_coin'),
      extra_coin: globalConfig.getHrefParam('extra_coin'),
      coinName: globalConfig.getHrefParam('coin_name'),
      mode: postOrderParams['mode'],
      userId: postOrderParams['userId'],
      SUCCESS: 1,
      FAIL: 0,
      WAITING: 2,
      postOrderParams,
      webviewEnv,
      postAction: '',
      post_fields: {},
      isWeb: '1', //写死为web,之前是从链接获取
      pageSource: postOrderParams['pageSource'],
      roleId: postOrderParams['roleId'],
      roleName: postOrderParams['roleName'],
      packageName: postOrderParams['packageName'],
      productRemark: postOrderParams['productRemark'],
      hasDoubleSend: postOrderParams['productRemark']?.includes?.(
        'SpecialParamWithDoubleSend'
      ),
      loading: false,
      showQuickPayTip:
        postOrderParams['f_pay_type'] === 'world_pay' ||
        (postOrderParams['f_pay_type'] === 'alipay' &&
          postOrderParams['pay_type'] &&
          postOrderParams['pay_type'].toLowerCase().indexOf('card') === 0),
      isShowQuickPayPopup: false,
      isUidLogin: postOrderParams['isUidLogin'] == '1',
      uid: postOrderParams['uid'],
      loginAccount: postOrderParams['loginAccount'],
      isCart: postOrderParams['submitType'] == '1',
      cartList: [],
      isShowOrderRecord: false,
      currency: postOrderParams['currency'],
      hasUseCoupon: postOrderParams['couponId'],
      couponInfoName: postOrderParams['couponInfoName'],
      discountAfterAmount: postOrderParams['discountAfterAmount'],
      cid: postOrderParams['cid'] ? postOrderParams['cid'] : '',
      scid: postOrderParams['scid'] ? postOrderParams['scid'] : '',
      productType: postOrderParams['productType']
        ? postOrderParams['productType']
        : '',
      productId: postOrderParams['productId']
        ? postOrderParams['productId']
        : '',
      cpProductId: postOrderParams['cpProductId']
        ? postOrderParams['cpProductId']
        : '',
      amount: postOrderParams['amount'] ? postOrderParams['amount'] : '',
      fPayType: postOrderParams['f_pay_type']
        ? postOrderParams['f_pay_type']
        : '',
      paytype: postOrderParams['paytype'] ? postOrderParams['paytype'] : '',
      priceSubCoinName: postOrderParams['priceSubCoinName']
        ? postOrderParams['priceSubCoinName']
        : '', // 渠道拆单道具名称
      priceExtraCoinName: postOrderParams['priceExtraCoinName']
        ? postOrderParams['priceExtraCoinName']
        : '', // 渠道加码道具名称
      productExtraCoin: postOrderParams['productExtraCoin']
        ? postOrderParams['productExtraCoin']
        : '', // 开发商加码PRODUCT_EXTRA_COIN
      productExtraCoinName: postOrderParams['productExtraCoinName']
        ? postOrderParams['productExtraCoinName']
        : '', // 开发商加码道具名称
      curTax: postOrderParams['curTax'] || 0,
      location: postOrderParams['location'] || ''
    };
  },
  beforeCreate() {
    this.$store.commit(UPDATE_GAMEID, gameId);
  },
  computed: {
    ...mapState({
      isCoinsSubmitType: state => state.isCoinsSubmitType,
      lang: state => state.lang
    }),
    ...mapGetters(['isJpPlatform']),
    gameName() {
      return gameId == 2
        ? '日替わり内室'
        : globalConfig.getHrefParam('game_name');
    },
    totalQuantity() {
      let totalQuantity = 0;
      this.cartList.forEach(item => {
        totalQuantity += +item.quantity;
      });
      return totalQuantity;
    },
    payResult() {
      let illegalPay = globalConfig.getHrefParam('illegal_pay') * 1;
      let transAmount = globalConfig.getHrefParam('trans_amount');
      let desc = this.postOrderParams && this.postOrderParams.productDesc;
      // 非点卡默认显示
      if (!transAmount) {
        return desc;
      }

      // sub_coin不为0说明为拆单情况
      if (+this.sub_coin && this.coinName && transAmount * 1 > 0) {
        let desArray = [this.sub_coin + ' ' + this.priceSubCoinName];
        if (this.extra_coin && this.extra_coin * 1 > 0) {
          desArray.push(this.extra_coin + ' ' + this.priceExtraCoinName);
        }
        /**
         *  illegalPay为1指点卡小买大，显示【渠道拆单内容+渠道加码内容】
         *  不为1说明大买小，显示【商品名 + 开发商加码PRODUCT_EXTRA_COIN + 渠道拆单内容 + 渠道加码内容 】
         */
        if (illegalPay === 1) {
          return desArray.join(` ${this.letter.and || 'and'} `);
        } else {
          // 有开发商加码，则拼接上
          if (+this.productExtraCoin) {
            desArray.unshift(
              this.productExtraCoin + ' ' + this.productExtraCoinName
            );
          }
          return desc.replace(
            /\s((\d*)|(\d*\.\d*))\s.*$/,
            ' ' + desArray.join(` ${this.letter.and || 'and'} `)
          );
        }
      }
      return desc;
    },
    letter() {
      return this.$store.state.letter;
    },
    priceAmount() {
      let currency = globalConfig.getHrefParam('currency');
      let transAmount = globalConfig.getHrefParam('trans_amount');
      if (currency && transAmount) {
        return changePriceFormat(currency, transAmount) + ' ' + currency;
      } else {
        // 日本平台固定写死单位：JPY
        let postCurrency = this.isJpPlatform
          ? 'JPY'
          : this.postOrderParams && this.postOrderParams.currency;
        let amountDesc =
          this.postOrderParams && this.postOrderParams.amountDesc;
        return changePriceFormat(postCurrency, amountDesc) + ' ' + postCurrency;
      }
    },
    cartPriceAmount() {
      let postCurrency = this.postOrderParams && this.postOrderParams.currency;
      let amountDesc = this.postOrderParams && this.postOrderParams.amount;
      return changePriceFormat(postCurrency, amountDesc) + ' ' + postCurrency;
    },
    showThemeConfig() {
      return this.$store.state.showThemeConfig;
    },
    amountDesc() {
      // 日本平台固定写死单位：JPY
      let postCurrency = this.isJpPlatform
        ? 'JPY'
        : this.postOrderParams && this.postOrderParams.currency;
      let amountDesc = this.postOrderParams && this.postOrderParams.amountDesc;
      return changePriceFormat(postCurrency, amountDesc) + ' ' + postCurrency;
    },
    newStoreSuccessTips() {
      // 2024/01/25 大掌柜支付页增加支付成功引导文案
      const dzgWebsiteList = [215, 213, 211, 209];
      if (dzgWebsiteList.includes(+this.gameId)) {
        return `${this.letter.storeSuccessTips} <br />
        ${
          gameInfoConfig[+gameId].storeSuccessEmailTips[this.lang] ||
          gameInfoConfig[+gameId].storeSuccessEmailTips['en-US'] ||
          ''
        }`;
      } else {
        return this.letter.storeSuccessTips;
      }
    },
    isShowTax() {
      return (
        +this.curTax > 0 &&
        this.location === 'US' &&
        this.paytype !== 'user_balance_pay'
      );
    }
  },
  created() {
    this.sendResultBiData();
    if (this.isCart) {
      this.getCart();
    }
  },
  methods: {
    sendResultBiData() {
      window.webstorev1DataLayer.push({
        eventName: 'payment_result',
        uid: this.uid,
        loginAccount: this.loginAccount || '',
        roleId: this.roleId || '',
        roleName: this.roleName || '',
        serverId: this.serverId,
        cid: this.cid,
        scid: this.scid,
        eventType: this.postOrderParams?.buyType,
        eventValue: {
          result: this.result,
          product_type: this.productType || '',
          cp_product_id: this.cpProductId || '',
          product_id: this.productId || '',
          product_num: '1',
          product_currency: this.currency || '',
          product_money: this.amount || '',
          local_currency: this.currency || '',
          local_money: this.amount || '',
          f_pay_type: this.fPayType || '',
          pay_type: this.paytype || '',
          order_id: this.orderId,
          ...this.postOrderParams?.biCouponInfo,
          uid: this.uid || '',
          loginAccount: this.loginAccount || '',
          roleId: this.roleId || '',
          roleName: this.roleName || '',
          serverId: this.serverId || '',
          cid: this.cid || '',
          scid: this.scid || ''
        }
      });
    },
    lookOrderRecord() {
      this.isShowOrderRecord = true;
      const dataEvent = {
        0: 'click-fail-cart-look-detail',
        1: 'click-succ-cart-look-detail',
        2: 'click-wait-cart-look-detail'
      };
      commonEmitUpload(dataEvent[+this.result], {
        event: dataEvent[+this.result],
        newPage: false,
        type: 'click'
      });
    },
    getCart() {
      this.$store
        .dispatch(GET_CART, this.orderId)
        .then(res => {
          this.cartList = res;
        })
        .catch(err => {
          console.log('cart err', err);
        });
    },
    backGame() {
      bridge.callSdkMethod('closeWebview');
    },
    showFeebackPage() {
      clickButton({
        btnName: 'contact_service',
        locationKey: locationType.resultPage
      });
      if (this.isJpPlatform) {
        this.jpService({
          gameId: this.gameId,
          pcServerId: this.sid,
          roleId: this.roleId,
          roleName: this.roleName,
          uid: this.uid
        });
        return;
      }
      let href = `https://gabres.${mainHost}/platform/webOfficialSupport.html${
        window.location.search
      }&roleId=${this.roleId}&serverId=${this.sid}&gameId=${
        this.gameId
      }&roleName=${this.roleName}&loginAccount=${this.loginAccount}&web=1${
        this.isUidLogin ? `&isUidLogin=1&uid=${this.uid}` : ''
      }`;
      if (bridge.runInsdk()) {
        bridge.callSdkMethod('openBrowser', {
          url: getGlobalGetGotoLink({ link: href }),
          loginDir: 1,
          appendParams: 1
        });
      } else {
        window.open(getGlobalGetGotoLink({ link: href }));
      }
    },
    reStore() {
      clickButton({
        btnName: 're_store',
        locationKey: locationType.resultPage
      });
      this.loading = true;
      if (this.isJpPlatform) {
        window.location.href =
          process.env.NODE_ENV !== 'production'
            ? getGlobalGetGotoLink({
                link: `https://gabres.${mainHost}/officialStore.html?gameId=${this.gameId}&cid=${this.cid}&scid=${this.scid}&mode=${this.mode}`
              })
            : getGlobalGetGotoLink({
                link: `https://jpstore.${window.atob(
                  'MzdnYW1lcy5jb20='
                )}/mobile/signin?gameId=${this.gameId}&cid=${this.cid}&scid=${
                  this.scid
                }&mode=${this.mode}`
              });
      } else {
        window.location.href =
          process.env.NODE_ENV !== 'production'
            ? getGlobalGetGotoLink({
                link: `https://gabres.${mainHost}/officialStore.html?gameId=${this.gameId}&cid=${this.cid}&scid=${this.scid}&mode=${this.mode}`
              })
            : getGlobalGetGotoLink({
                link: `https://pay.${mainHost}/platform/officialStore.html?gameId=${this.gameId}&cid=${this.cid}&scid=${this.scid}&mode=${this.mode}`
              });
      }
    }
  },
  components: {
    ServiceIconBtn,
    QuickPayCardPopup,
    TopHeader,
    CartOrderRecord,
    ThemeConfig: () => import('@components/officialStore/ThemeConfig.vue')
  }
};
</script>
<style lang="scss" scoped>
#pay-result {
  position: relative;
  min-width: 100vw;
  min-height: 100vh;
  background-color: var(--page-bg);
  @psetbg ('result-bg.png',false,false);
  background-size: cover;
}
.top-header {
  position: relative;
}
.result-info-container {
  position: relative;
  width: 100%;
}
.order-info-wrapper {
  display: inline-block;
  margin-top: 52px;
  margin-bottom: 52px;
  width: 100%;
  .order-info-container {
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 30px;
    width: 679px;
    background: var(--result-order-bg);
    font-size: 30px;
    color: var(--result-order-text);
  }
  .game-info {
    display: inline-block;
    border-bottom: 1px solid #e6e6e6;
    width: 100%;
    min-height: 80px;
    line-height: 80px;
  }
  .order-info {
    display: inline-block;
    padding-top: 22px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e6e6e6;
    width: 100%;
  }
  .payment-info {
    border-bottom-width: 0;

    @extend .order-info;
  }
  .order-info-list,
  .payment-info-list {
    display: inline-block;
    width: 100%;
    line-height: 52px;
  }
}
.follow-operation {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  margin: 30px auto;
  padding-bottom: 30px;
  width: 100%;
  .follow-operation-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    background-size: cover;
    text-align: center;
    font-size: 36px;
    color: var(--result-btn);
    @psetbg ('result-restore-btn.png');
    &.contact-us {
      cursor: pointer;
      @psetbg ('result-contact-btn.png');
    }
  }
  .follow-operation-btn-text {
    display: inline-block;
    vertical-align: middle;
  }
}
.look-detail {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: var(--result-look-more);
}
.opera-tips {
  margin: 0 auto;
  margin-bottom: 80px - 54px;
  width: 679px;
  line-height: 30px;
  text-align: left;
  font-size: 22px;
  color: var(--result-tip-text);
  &.look-more {
    cursor: pointer;
    color: var(--result-look-more);
  }
  &.mb0 {
    margin-bottom: 0;
  }
}
.middleMark {
  font-size: 32px;
  color: var(--result-error-tip);
}
.bigMark {
  font-size: 36px;
  color: var(--result-error-tip);
  &.highlight {
    color: var(--result-discount) !important;
  }
  &.normal {
    color: var(--result-tip-text) !important;
  }
}
.pay-errmsg {
  display: inline-block;
  max-width: 100%;
  word-break: break-word;
}
@media screen and (orientation: landscape) {
  #pay-result {
    overflow-x: hidden;
    @psetbg ('result-bg-hen.png',false,false);
    background-size: 100% 100% !important;
  }
  .result-info-container {
    margin-left: auto;
    margin-right: auto;
    width: 703px;
  }
  .follow-operation-btn {
    margin-bottom: 32px;
  }
}
</style>
